import { Box, Typography } from '@mui/material';
import { useTenant } from '../contexts/TenantContext';
import { gradientTextSx } from '../utils/textStyles';

const BorderedBox = ({ fixWidth, title, titleColor, lable, children }) => {
  const { displayConfig } = useTenant(); 

  return (
    <Box>
      {title && <Typography sx={gradientTextSx(displayConfig, titleColor || displayConfig.color)} gutterBottom>{title}</Typography>}

      <Box
        sx={{
          p: 2,
          borderRadius: "5px",
          border: `1px solid ${displayConfig?.primaryColor}`,
          minWidth: fixWidth,
          maxWidth: fixWidth,
          color: displayConfig.color,
        }}
      >
        { lable ? lable : children}
      </Box>
    </Box>
  );
};

export default BorderedBox;
